import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from './utils/vi18n'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/index.scss";
import VMdPreview from '@kangc/v-md-editor/lib/preview.js'
import '@kangc/v-md-editor/lib/style/preview.css'
// markdown 主题
import vuepress from '@kangc/v-md-editor/lib/theme/vuepress.js'
import '@kangc/v-md-editor/lib/theme/style/vuepress.css'
import emoji from '@kangc/v-md-editor/lib/plugins/emoji/index'
import '@kangc/v-md-editor/lib/plugins/emoji/emoji.css'
import '@/utils/markdown.js'



Vue.config.productionTip = false;
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
});
// VMdPreview.use(vuepress)
// VMdPreview.use(emoji)
//     // md 插件
// Vue.use(VMdPreview)

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");